import { render, staticRenderFns } from "./ShowBackups.vue?vue&type=template&id=5c7f2bed&scoped=true"
import script from "./ShowBackups.vue?vue&type=script&lang=js"
export * from "./ShowBackups.vue?vue&type=script&lang=js"
import style0 from "./ShowBackups.vue?vue&type=style&index=0&id=5c7f2bed&prod&lang=css"
import style1 from "./ShowBackups.vue?vue&type=style&index=1&id=5c7f2bed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f2bed",
  null
  
)

export default component.exports